﻿<template>
    <div class="container">
        <div class="mb-3">{{ $t('productAddedToast') }}</div>

        <div class="row d-flex justify-content-between">

            <div class="col-12">
                <a href="/quote" class="btn btn-primary btn-md rounded-pill btn-trimm-wide">
                    {{ $t('goToCart') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'quote-toast',
    };
</script>